import { PillTheme } from "@redotech/redo-model/pill-theme";
import { memo } from "react";
import { RedoTextInput } from "../arbiter-components/input/redo-text-input";
import { Flex } from "../flex";
import { Text } from "../text";
import { PillColorPicker } from "./tag-input-color-picker";
import { TagPillThemes } from "./tag-pill";

export const TagInputFields = memo(function TagInputFields({
  name,
  setName,
  pillTheme,
  setPillTheme,
  showNameError,
  disableNameEdit = false,
}: {
  name: string;
  setName(name: string): void;
  showNameError: boolean;
  pillTheme: PillTheme;
  setPillTheme(pillTheme: PillTheme): void;
  disableNameEdit?: boolean;
}) {
  return (
    <Flex dir="column" gap="3xl" p="sm">
      <Flex dir="column" gap="xs">
        <RedoTextInput
          label="Tag name"
          setValue={setName}
          state={disableNameEdit ? "readonly" : "default"}
          value={name}
        />
        {showNameError && (
          <Text
            fontSize="xs"
            pl="sm"
            textColor="error"
          >{`A tag with the name ${name} already exists`}</Text>
        )}
      </Flex>
      <PillColorPicker
        label="Tag color"
        options={TagPillThemes}
        setValue={setPillTheme}
        value={pillTheme}
      />
    </Flex>
  );
});
